(() => {
  'use strict';

  const FORM_SELECTOR = '#cart-form_ppr';
  const PAYMENT_SELECTOR = '.shopify-payment-button';
  const BUTTON_CLASS = 'gw-king-buy-now';
  const ADD_WRAPPER_CLASS = 'gw-king-add-wrapper';
  const PAYMENT_WRAPPER_CLASS = 'gw-king-payment-wrapper';
  const CHECKOUT_TEXT = 'BUY IT NOW';
  const LOADING_TEXT = 'PROCESSING...';
  const POLL_INTERVAL = 500;
  const POLL_LIMIT = 180;

  let setupQueued = false;
  let buyNowPending = false;

  const delay = (milliseconds) =>
    new Promise((resolve) => window.setTimeout(resolve, milliseconds));

  const visible = (element) => {
    if (!element) return false;
    const style = window.getComputedStyle(element);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      element.getBoundingClientRect().height > 0
    );
  };

  const variantIsAvailable = (form) => {
    const addToCart = form.querySelector('.single_add_to_cart_button');
    const outOfStock = form.querySelector('.out_stock');
    return (
      addToCart &&
      !addToCart.disabled &&
      visible(addToCart) &&
      !visible(outOfStock)
    );
  };

  const selectedVariantId = (form) => {
    const variantInput = form.querySelector('[name="id"]');
    return variantInput ? Number(variantInput.value) : 0;
  };

  const variantQuantityInCart = (cart, variantId) =>
    (cart.items || [])
      .filter((item) => Number(item.variant_id) === Number(variantId))
      .reduce((quantity, item) => quantity + Number(item.quantity || 0), 0);

  const getCart = () =>
    window
      .fetch(`${window.Shopify?.routes?.root || '/'}cart.js?gw_buy_now=${Date.now()}`, {
        credentials: 'same-origin',
        cache: 'no-store',
      })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to read the cart');
        return response.json();
      });

  const resetButton = (button) => {
    buyNowPending = false;
    button.disabled = false;
    button.classList.remove('is-loading');
    button.textContent = CHECKOUT_TEXT;
  };

  const goToCheckout = () => {
    const root = window.Shopify?.routes?.root || '/';
    window.location.assign(`${root}checkout`);
  };

  const waitForKingCartAdd = async (button, variantId, quantityBefore) => {
    for (let attempt = 0; attempt < POLL_LIMIT; attempt += 1) {
      await delay(POLL_INTERVAL);
      try {
        const cart = await getCart();
        if (variantQuantityInCart(cart, variantId) > quantityBefore) {
          goToCheckout();
          return;
        }
      } catch (error) {
        // A transient cart read should not interrupt an in-progress file upload.
      }
    }
    resetButton(button);
  };

  const handleBuyNow = async (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    const form = button.closest('form');
    if (!form || buyNowPending || !variantIsAvailable(form)) return;

    const addToCart = form.querySelector('.single_add_to_cart_button');
    const appWrapper =
      addToCart.parentElement &&
      addToCart.parentElement.tagName === 'SPAN' &&
      addToCart.parentElement.wrapper
        ? addToCart.parentElement
        : addToCart;
    const variantId = selectedVariantId(form);
    if (!appWrapper || !variantId) return;

    buyNowPending = true;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = LOADING_TEXT;

    try {
      const cartBefore = await getCart();
      const quantityBefore = variantQuantityInCart(cartBefore, variantId);
      appWrapper.click();
      waitForKingCartAdd(button, variantId, quantityBefore);
    } catch (error) {
      resetButton(button);
    }
  };

  const ensureButton = () => {
    setupQueued = false;
    const form = document.querySelector(FORM_SELECTOR);
    const payment = form && form.querySelector(PAYMENT_SELECTOR);
    if (!form || !payment) return;

    const addToCart = form.querySelector('.single_add_to_cart_button');
    const addWrapper =
      addToCart &&
      addToCart.parentElement &&
      addToCart.parentElement.tagName === 'SPAN' &&
      addToCart.parentElement.wrapper
        ? addToCart.parentElement
        : null;
    const paymentWrapper =
      payment.parentElement &&
      payment.parentElement.tagName === 'SPAN' &&
      payment.parentElement.wrapper
        ? payment.parentElement
        : null;

    if (addWrapper) addWrapper.classList.add(ADD_WRAPPER_CLASS);
    if (paymentWrapper) {
      paymentWrapper.classList.add(PAYMENT_WRAPPER_CLASS);
    }

    let button = form.querySelector(`.${BUTTON_CLASS}`);
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = BUTTON_CLASS;
      button.textContent = CHECKOUT_TEXT;
      button.addEventListener('click', handleBuyNow);

      (paymentWrapper || payment).insertAdjacentElement('afterend', button);
    }

    const paymentStyle = window.getComputedStyle(payment);
    const kingHasHiddenPayment =
      paymentStyle.display === 'none' ||
      paymentStyle.visibility === 'hidden' ||
      Number(paymentStyle.opacity) === 0;

    button.classList.toggle(
      'is-visible',
      kingHasHiddenPayment && variantIsAvailable(form)
    );
  };

  const queueSetup = () => {
    if (setupQueued) return;
    setupQueued = true;
    window.requestAnimationFrame(ensureButton);
  };

  const start = () => {
    queueSetup();
    const observer = new MutationObserver(queueSetup);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'disabled'],
    });
    document.addEventListener('change', queueSetup);
    document.addEventListener('click', (event) => {
      if (event.target.closest('.nt-swatch, .qty, .plus, .minus')) {
        window.setTimeout(queueSetup, 50);
      }
    });
    [250, 750, 1500, 3000, 6000].forEach((timeout) =>
      window.setTimeout(queueSetup, timeout)
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
